import React from 'react';
import useCurrentUserRoles from '../../hooks/useCurrentUserRoles';
import SidebarMenuItem from './SidebarMenuItem';
import { Book, CircleNodes } from '@raydiant/raydial/components/Icons';
import {
  selectIsEnterpriseUser,
  selectIsLiteUser,
  selectIsRestrictedUser,
} from '../../selectors/user';
import { useSelector } from 'react-redux';
import * as paths from '../../routes/paths';
import Divider from '@raydiant/raydial/components/Divider';

interface NavigationSubMenu {
  href: string;
  label: string;
}

export interface NavigationMenu extends NavigationSubMenu {
  icon: React.ReactNode;
  subItems?: NavigationSubMenu[];
}

export const NAVIGATION: NavigationMenu[] = [
  {
    href: '/screens',
    label: 'screens.pageTitle',
    icon: (
      <svg
        fill="currentColor"
        className="size-6 text-inherit"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
      >
        <path d="M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z" />
      </svg>
    ),
    subItems: [],
  },
  {
    href: '/library',
    label: 'library.pageTitle',
    icon: (
      <svg
        className="size-6 text-inherit"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
      >
        <path d="M192 64c0-35.3 28.7-64 64-64H576c35.3 0 64 28.7 64 64v69.6c-12.9-6.1-27.9-7.1-41.7-2.5l-98.9 33-37.8-60.5c-2.9-4.7-8.1-7.5-13.6-7.5s-10.6 2.8-13.6 7.5L388 177.9l-15.3-19.7c-3-3.9-7.7-6.2-12.6-6.2s-9.6 2.3-12.6 6.2l-56 72c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9h64l0 64H256c-35.3 0-64-28.7-64-64V64zM319.5 404.6c-13.8 10.3-25.2 25.2-29.6 43.4H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h96V360c0 17.7 14.3 32 32 32H342.2c-8.2 3.3-15.8 7.5-22.6 12.6zM320 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM56 168v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V264c0-8.8-7.2-16-16-16H72zM56 360v16c0 8.8 7.2 16 16 16H88c8.8 0 16-7.2 16-16V360c0-8.8-7.2-16-16-16H72c-8.8 0-16 7.2-16 16zM630 164.5c6.3 4.5 10 11.8 10 19.5v48V392c0 1.2-.1 2.4-.3 3.6c.2 1.5 .3 2.9 .3 4.4c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V265.3l-144 48V464c0 26.5-28.7 48-64 48s-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .5 16 1.5V296 248c0-10.3 6.6-19.5 16.4-22.8l192-64c7.3-2.4 15.4-1.2 21.6 3.3z" />
      </svg>
    ),
    subItems: [],
  },
  {
    href: '/marketplace',
    label: 'marketplace.pageTitle',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        className="size-6 text-inherit"
        viewBox="0 0 576 512"
      >
        <path d="M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z" />
      </svg>
    ),
    subItems: [],
  },
  {
    href: '/analytics',
    label: 'analytics.analytics',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        className="size-6 text-inherit"
        viewBox="0 0 512 512"
      >
        <path d="M503.6 74.2c10.1-8.6 11.2-23.8 2.6-33.8s-23.8-11.2-33.8-2.6L320.2 168.3 207.8 69.9c-8.2-7.1-20.1-7.9-29.1-1.9L10.7 180c-11 7.4-14 22.3-6.7 33.3s22.3 14 33.3 6.7L190 118.2l114.2 99.9c9 7.9 22.4 7.9 31.4 .2l168-144zM200 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V272c0-4.4 3.6-8 8-8s8 3.6 8 8V432zm-8-208c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM72 432c0 4.4-3.6 8-8 8s-8-3.6-8-8V368c0-4.4 3.6-8 8-8s8 3.6 8 8v64zM64 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48V368c0-26.5-21.5-48-48-48zm264 16v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V336c0-4.4 3.6-8 8-8s8 3.6 8 8zm-56 0v96c0 26.5 21.5 48 48 48s48-21.5 48-48V336c0-26.5-21.5-48-48-48s-48 21.5-48 48zm184 96c0 4.4-3.6 8-8 8s-8-3.6-8-8V272c0-4.4 3.6-8 8-8s8 3.6 8 8V432zm-8-208c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48z" />
      </svg>
    ),
    subItems: [
      {
        href: '/analytics',
        label: 'analytics.analytics',
      },
      {
        href: '/analytics/content',
        label: 'analytics.contentEngagementPage.title',
      },
    ],
  },
];

const gettingStartedNavigation = [
  {
    href: '/getting-started',
    label: 'Getting Started',
    icon: (
      <svg
        fill="currentColor"
        className="size-6 text-inherit"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="2 2 28 28"
      >
        <path d="M19.75 7.89062L19.7031 7.46875C19.5625 6.48438 18.7656 5.73438 17.7812 5.59375L17.3594 5.5C16.9844 5.45312 16.7031 5.07812 16.75 4.65625C16.7969 4.28125 17.1719 3.95312 17.5938 4.04688L17.9688 4.09375C19.6562 4.32812 20.9219 5.64062 21.1562 7.28125L21.2031 7.65625C21.2969 8.07812 21.0156 8.45312 20.5938 8.5C20.1719 8.59375 19.7969 8.3125 19.75 7.89062ZM7.75 7.23438C8.54688 6.39062 9.76562 6.15625 10.8438 6.53125C10.9844 6.20312 11.1719 5.92188 11.4531 5.64062C12.625 4.46875 14.5 4.46875 15.6719 5.64062L21.25 11.1719V10.9375C21.25 9.29688 22.5625 7.9375 24.25 7.9375C25.8906 7.9375 27.25 9.29688 27.25 10.9375V18.3438C27.25 18.4375 27.25 18.4844 27.2031 18.5781L27.25 18.625C27.25 23.7812 23.0781 28 17.9219 28H17.875H17.5469C15.0625 28 12.6719 27.0156 10.9375 25.2812L5.59375 19.9844C4.42188 18.8125 4.42188 16.8906 5.59375 15.7188C5.78125 15.5312 5.96875 15.3906 6.20312 15.25L6.15625 15.2031C4.98438 14.0312 4.98438 12.1094 6.15625 10.9375C6.39062 10.7031 6.67188 10.4688 7 10.3281C6.67188 9.29688 6.90625 8.07812 7.75 7.23438ZM11.4531 9.90625L10.375 8.82812C10.0938 8.54688 9.625 8.54688 9.34375 8.82812C9.01562 9.10938 9.01562 9.625 9.34375 9.90625L10.375 10.9375L14.875 15.4375C15.3438 15.9062 15.3438 16.6094 14.875 17.0312C14.4531 17.5 13.75 17.5 13.2812 17.0312L8.78125 12.5312C8.5 12.25 8.03125 12.25 7.75 12.5312C7.42188 12.8125 7.42188 13.3281 7.75 13.6094L9.57812 15.4375V15.4844L12.25 18.1094C12.6719 18.5781 12.6719 19.2812 12.25 19.7031C11.7812 20.125 11.0781 20.125 10.6562 19.7031L8.26562 17.3125C7.98438 17.0312 7.46875 17.0312 7.1875 17.3125C6.90625 17.5938 6.90625 18.0625 7.1875 18.3906L12.4844 23.6875C13.8438 25 15.6719 25.75 17.5469 25.75H17.875C21.7656 25.75 24.9062 22.6094 24.9531 18.7656C24.9531 18.7188 24.9531 18.6719 24.9531 18.625C24.9531 18.5312 24.9531 18.4375 24.9531 18.3438V10.9375C24.9531 10.5625 24.625 10.1875 24.2031 10.1875C23.8281 10.1875 23.4531 10.5625 23.4531 10.9375V13.8906C23.4531 14.3594 23.2188 14.7812 22.7969 14.9688C22.375 15.1094 21.8594 15.0156 21.5312 14.6875L14.0781 7.23438C13.7969 6.95312 13.3281 6.95312 13.0469 7.23438C12.7656 7.51562 12.7656 7.98438 13.0469 8.3125L17.5469 12.8125C17.9688 13.2344 17.9688 13.9844 17.5469 14.4062C17.0781 14.8281 16.375 14.8281 15.9531 14.4062L11.4531 9.90625ZM4.60938 21.2969C5.03125 21.2031 5.40625 21.4844 5.45312 21.9062L5.54688 22.3281C5.6875 23.3125 6.4375 24.0625 7.42188 24.2031L7.84375 24.2969C8.21875 24.3438 8.54688 24.7188 8.45312 25.1406C8.40625 25.5156 8.03125 25.8438 7.60938 25.75L7.23438 25.7031C5.59375 25.4688 4.28125 24.1562 4.04688 22.5156L4 22.1406C3.95312 21.7188 4.23438 21.3438 4.60938 21.2969Z" />
      </svg>
    ),
  },
];

const productHubNavigation = [
  {
    href: '/catalogs',
    label: 'catalogs.pageTitle',
    icon: <Book className="size-6" />,
  },
  {
    href: '/integrations',
    label: 'integrations.pageTitle',
    icon: <CircleNodes className="size-6" />,
  },
];

type SidebarMenuProps = {
  isOpen: boolean;
  onTopMenuClick: (value: boolean) => void;
};

const SidebarMenu = ({ isOpen, onTopMenuClick }: SidebarMenuProps) => {
  const roles = useCurrentUserRoles();
  const isEnterpriseUser = useSelector(selectIsEnterpriseUser);
  const isRestrictedUser = useSelector(selectIsRestrictedUser);
  const isLiteUser = useSelector(selectIsLiteUser);

  const analyticsMenuItem = NAVIGATION.find((navigation) =>
    navigation.href.match(/analytics/),
  );

  const getDefaultAnalytics = () => {
    if (roles.isRXEnabled) {
      return '/analytics';
    }
    if (roles.isVIEnabled || roles.isVIOnlyEnabled) {
      return '/analytics/traffic';
    }
    return '/analytics/content';
  };

  const renderAnalyticsMenu = () => {
    const analyticsMenu = {
      href: getDefaultAnalytics(),
      icon: analyticsMenuItem?.icon,
      label: 'analytics.analytics',
      subItems: [] as NavigationSubMenu[],
    };

    analyticsMenu.subItems = [
      ...analyticsMenu.subItems,
      {
        href: '/analytics/traffic',
        label: 'analytics.trafficAwarenessPage.title',
      },
    ];

    analyticsMenu.subItems = [
      ...analyticsMenu.subItems,
      {
        href: '/analytics/content',
        label: 'analytics.contentEngagementPage.title',
      },
    ];

    analyticsMenu.subItems = [
      ...analyticsMenu.subItems,
      {
        href: '/analytics',
        label: 'Product Engagement',
      },
    ];

    analyticsMenu.subItems = roles.isContentDetailEnabled
      ? [
          ...analyticsMenu.subItems,
          {
            href: '/analytics/content/detail',
            label: 'analytics.contentDetailPage.navBarTitle',
          },
        ]
      : [...analyticsMenu.subItems];

    return analyticsMenu;
  };

  const viOnlyDefaultNavigation = {
    href: '/screens',
    label: 'Devices',
    icon: (
      <svg
        fill="currentColor"
        className="size-6 text-inherit"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 512"
      >
        <path d="M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z" />
      </svg>
    ),
    subItems: [],
  };

  const index = NAVIGATION.findIndex(
    (item) => item.href === paths.library.pattern,
  );

  const nextSubItems: NavigationSubMenu[] = [
    {
      href: paths.library.pattern,
      label: 'My Library',
    },
  ];

  if (isEnterpriseUser) {
    nextSubItems.push({
      href: paths.librarySharedWithMe.pattern,
      label: 'Shared with Me',
    });

    nextSubItems.push({
      href: paths.librarySharedLibraries.pattern,
      label: 'Shared Libraries',
    });

    if (!isRestrictedUser) {
      nextSubItems.push({
        href: paths.libraryUsersLibraries.pattern,
        label: 'User Libraries',
      });
    }

    NAVIGATION[index].label = 'Libraries';
    NAVIGATION[index].subItems = [...nextSubItems];
  }

  return (
    <ul className="menu">
      {roles.isProUser &&
        gettingStartedNavigation.map((link) => {
          return (
            <React.Fragment key={link.href}>
              <SidebarMenuItem
                menuItem={link}
                onTopMenuClick={onTopMenuClick}
              />
              <div>
                <Divider className="mx-6 border-gray-200 mb-3" />
              </div>
            </React.Fragment>
          );
        })}
      {!roles.isVIOnlyEnabled &&
        NAVIGATION.filter((link) => {
          if (
            isLiteUser &&
            (link.href === '/marketplace' || link.href === '/analytics')
          ) {
            return false;
          }
          return link.href !== analyticsMenuItem?.href;
        }).map((link) => {
          return (
            <SidebarMenuItem
              key={link.href}
              menuItem={link}
              onTopMenuClick={onTopMenuClick}
            />
          );
        })}
      {roles.isVIOnlyEnabled && (
        <SidebarMenuItem
          menuItem={viOnlyDefaultNavigation}
          onTopMenuClick={onTopMenuClick}
        />
      )}
      {roles.isProductHubEnabled &&
        !isLiteUser &&
        productHubNavigation.map((link) => {
          return (
            <SidebarMenuItem
              key={link.href}
              menuItem={link}
              onTopMenuClick={onTopMenuClick}
            />
          );
        })}
      {!isLiteUser && (
        <SidebarMenuItem
          menuItem={renderAnalyticsMenu()}
          onTopMenuClick={onTopMenuClick}
        />
      )}
    </ul>
  );
};

export default SidebarMenu;
